// Neutral, professional role badge styling. We intentionally avoid per-role
// rainbow colours (they read as "funky" and inconsistent). Every role uses the
// same muted treatment via theme tokens; the role name itself carries meaning.

/** Tailwind classes (bg + text + border) for a role badge/chip. */
export function roleBadgeClasses(_role: { id: number; name: string }): string {
  return 'bg-muted text-foreground border-border'
}
